import { TableCell, Typography } from "@mui/material";

const SiteAndPhysicianCell = ({
  treatingDepartment,
  treatingRo,
}: {
  treatingDepartment: string;
  treatingRo: string;
}) => {
  return (
    <TableCell sx={{ minWidth: "160px" }}>
      <Typography variant="body2">{treatingDepartment}</Typography>
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
        }}
      >
        {treatingRo}
      </Typography>
    </TableCell>
  );
};

export default SiteAndPhysicianCell;
